export enum GitFileStatus {
    ' ',
    'M',
    'D',
    '?',
}
